import { useEffect } from "react";

export const useDebugLog = (dependence)  => {
    useEffect(() => {
        console.log(`debugData: `, dependence)
    }, [dependence])
}